import { Tool } from '../../types';

export const accountingTools: Tool[] = [
  {
    id: 'quickbooks',
    name: 'QuickBooks',
    category: 'Accounting',
    description: 'Comprehensive accounting software for small to medium-sized businesses. Streamline invoicing, automate bookkeeping, track expenses in real-time, and manage payroll. Integrates with 500+ business apps for seamless financial workflows.',
    pricing: ['medium', 'high'],
    features: ['invoicing', 'automation', 'mobile', 'integrations'],
    bestFor: ['small-business', 'trades', 'freelancer'],
    compatibleWith: ['service-business', 'consulting-firm', 'e-commerce', 'agency'],
    goals: ['streamline-operations', 'reduce-costs'],
    industries: ['retail', 'trades', 'consulting', 'home-services'],
    website: 'https://quickbooks.partnerlinks.io/l6pblxl5sc4w',
    imageUrl: 'https://logo.clearbit.com/quickbooks.intuit.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'freshbooks',
    name: 'FreshBooks',
    category: 'Accounting',
    description: 'User-friendly invoicing and accounting software designed specifically for freelancers and small businesses. Create professional invoices in seconds, track time automatically, manage expenses on-the-go, and get paid faster with online payments.',
    pricing: ['low', 'medium'],
    features: ['invoicing', 'ease-of-use', 'mobile', 'time-tracking'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['service-business', 'consulting-firm', 'content-creator'],
    goals: ['streamline-operations', 'reduce-costs'],
    industries: ['creative', 'consulting', 'marketing'],
    website: 'https://www.freshbooks.com',
    imageUrl: 'https://logo.clearbit.com/freshbooks.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'xero',
    name: 'Xero',
    category: 'Accounting',
    description: 'Cloud-based accounting platform with powerful automation and real-time collaboration features. Connect your bank for automatic reconciliation, manage multi-currency transactions, and access 1000+ app integrations for a complete financial ecosystem.',
    pricing: ['medium'],
    features: ['invoicing', 'automation', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['service-business', 'consulting-firm', 'e-commerce'],
    goals: ['streamline-operations', 'reduce-costs'],
    industries: ['retail', 'consulting', 'creative'],
    website: 'https://www.xero.com',
    imageUrl: 'https://logo.clearbit.com/xero.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];